import OTP from '@rashidpathiyil/otp-input';

export const setPinInputs = (inputs: string, result: string): void => {
    const initOTPInput = new OTP(
        inputs,
        result
    );
}